import { Alert, AlertProps, Typography } from "antd";

import styles from "./amlAlert.module.css";
import { AmlRiskMessage } from "interfaces";

interface IProps extends AlertProps {
  amlMessage: AmlRiskMessage;
}

export const AmlAlert = (props: IProps) => {
  const { amlMessage, ...restProps } = props;

  return (
    <Alert
      message={
        <Typography.Text strong className="text-small">
          {amlMessage.message}
        </Typography.Text>
      }
      description={<Typography.Text className={styles.amlResultDescription}>{amlMessage.description}</Typography.Text>}
      type={amlMessage.type}
      showIcon
      {...restProps}
    />
  );
};
